'use client'

import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { Reveal } from '@/components/site/reveal'
import { SiteSection } from '@/components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

export function HomeMcpSection() {
  const { t } = useTranslation(['web'])
  return (
    <SiteSection trackingKey="mcp" className="pt-0">
      <Reveal>
        <h3 data-display-font="" className="font-display text-2xl leading-[1.3] font-semibold">
          {t('web:homePage.mcp.title')}
        </h3>
        <p className="mt-2 text-md leading-[1.65] text-muted">
          {t('web:homePage.mcp.description')}
        </p>
        <Link
          href="/mcp-connector"
          onClick={() => trackSiteLinkClicked('mcp', '/mcp-connector')}
          className="mt-[18px] inline-block border-b border-brand/34 text-md font-normal text-brand transition-colors hover:border-brand-hover hover:text-brand-hover focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
        >
          {t('web:homePage.mcp.cta')}
        </Link>
      </Reveal>
    </SiteSection>
  )
}
